/** @format */

/**
 * 数值区间筛选项：标签 + 起止两个 Input（失焦时提交）。
 * 用于会话分析侧栏，样式与 FilterItem 单行布局对齐。
 */

import React from 'react'
import { _$, Spinner, Tooltip } from '@king-design/react'
import styled from 'styled-components'
import { FilterRangeValueProps } from '../../SessionAnalysis/typescript'

export interface FilterRangeItemProps {
  className?: string
  label: string
  start: number | 0
  end: number | 0
  suffix?: string
  onChange: (key: string, patch: Partial<Pick<FilterRangeValueProps, 'Start' | 'End'>>) => void
  fieldKey: string
}

const FilterRangeItem: React.FC<FilterRangeItemProps> = ({
  className,
  label,
  start,
  end,
  suffix,
  onChange,
  fieldKey
}) => (
  <div className={className}>
    <span className="session_filter_label session_filter_label_range">
      {label} {suffix ? `(${suffix})` : ''}
    </span>
    <div className="session_filter_range">
      <Spinner
        className="session_filter_range_input"
        value={start}
        vertical
        min={0}
        precision={0}
        onChange={value => {
          onChange(fieldKey, { Start: value })
        }}
      />
      <span className="range-sep">-</span>
      <Tooltip theme="light" content={_$('仅支持输入整数')}>
        <Spinner
          className="session_filter_range_input"
          value={end}
          vertical
          min={0}
          precision={0}
          onChange={value => {
            onChange(fieldKey, { End: value })
          }}
        />
      </Tooltip>
    </div>
  </div>
)

export default styled(FilterRangeItem)`
  width: 100%;
  min-width: 0;
  margin-top: 8px;

  .session_filter_label {
    font-size: 12px;
    line-height: 18px;
  }

  .session_filter_range {
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: center;
    margin-top: 10px;

    .session_filter_range_input {
      width: 84px;
      .k-spinner-input {
        width: 84px;
      }
    }

    .range-sep {
      width: 20px;
      text-align: center;
      color: var(--k-text-placeholder-color, rgba(0, 0, 0, 0.45));
    }
  }
`
